import { Box, Chip } from '@mui/material';
import styled from 'styled-components';

export const StyledBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const StyledSelectedTeams = styled.div`
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  margin-top: 40px;
`;
export const StyledHeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
`;

export const StyledExpandableContent = styled.div<{ expanded: boolean }>`
  max-height: ${(props) => (props.expanded ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
`;

export const StyledChipWrapper = styled.div`
  text-align: center;
  margin-top: 10px;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 10px;
  text-align: center;
`;

export const StyledChip = styled(Chip)`
  border: 1px solid #5664f5;
`;

export const StyledButtonBox = styled(Box)`
  display: flex;
  justify-content: center;
`;
